export default __webpack_public_path__ + "static/media/Screenshot_12.50b7419e.png";